import React from "react";
import { Resources } from "../resources";

const footerFontSize = {
  fontSize: "30px",
  padding: "10px"
};

class Footer extends React.Component {
  render() {
    return (
      <div className="footer">
        <div className="footer-container">
          <div>{Resources.companyName}</div>
          <div>
            Call: <a href="tel: 1 (647) 862-2009">{Resources.phoneNumber}</a>
          </div>
        </div>
        <div className="footer-container">
          <img
            alt="Window Outfitter"
            height="150"
            src="/logo.png"
          />
        </div>
        <div className="footer-container">
          <div>Follow us on:</div>
          <div className="social-media">
            <a href={Resources.socialInstagram}>
              <i className="fab fa-instagram" style={footerFontSize} />
            </a>
            {/* <i className="fab fa-facebook" style={footerFontSize} /> */}
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js